import type { ReactNode } from "react"
import Popover from "@/v2-ui/popover"
import { useSelectorContext } from "./selector.context"
import SelectorCommand from "./SelectorCommand"

export type SelectorContentProps = {
  children: ReactNode
}

function SelectorContent(props: SelectorContentProps) {
  const { children } = props
  const { shouldFilter, side, align } = useSelectorContext()

  return (
    <Popover.Content
      side={side}
      align={align}
      // The placement was resolved from the trigger when the popover opened
      // (Selector) and holds until it closes; Radix must not flip the list
      // to the other side as results change its height. The content caps
      // itself to the room on that side and scrolls instead (selector.css).
      avoidCollisions={false}
      className="selector-content p-0"
    >
      <SelectorCommand shouldFilter={shouldFilter}>{children}</SelectorCommand>
    </Popover.Content>
  )
}

export default SelectorContent
